import { routerReducer, RouterReducerState } from '@ngrx/router-store';
import { ActionReducerMap, MetaReducer } from '@ngrx/store';
import { environment } from '../../../../environments/environment';
import * as fromAuth from '../auth/auth.reducer';
import * as fromMapLayers from '../projects/projects.reducer';
import * as fromResults from '../results/results.reducer';

// library to prevent mutatation of the state

export interface State {
  router: RouterReducerState;
  results: fromResults.State;
  auth: fromAuth.State;
  projects: fromMapLayers.State;
}

export const reducers: ActionReducerMap<State> = {
  router: routerReducer,
  results: fromResults.reducer,
  auth: fromAuth.reducer,
  projects: fromMapLayers.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? []
  : [];
